import React from "react";
import Dropdown from "../../../../dropdown/Dropdown";
import {FilterableColumn, FilterRule} from "../../../styledTableHelper";
import {getOptionsFromArray} from "../../../../dropdown/DropdownHelper";
import {getDropdownOptionFromValue} from "../../../../dropdown/DropdownHelper";
import {SingleValue} from "react-select";
import {Option} from "../../../../dropdown/DropdownHelper";
import styles from "./FilterDropdown.module.scss";

type FilterDropdownProps = {
  column: FilterableColumn;
  draftFilterRules: FilterRule[];
  updateDraftFilterRules: (rule: FilterRule) => void;
};

export default function FilterDropdown({
  column,
  draftFilterRules,
  updateDraftFilterRules,
}: FilterDropdownProps) {
  const existingRule = draftFilterRules.find(
    (rule) => rule.columnId === column.columnId
  );
  const options = getOptionsFromArray(column.columnOptions ?? []);
  const existingValue = getDropdownOptionFromValue(
    options,
    existingRule?.value ?? ""
  );

  const updateFilterRule = (value: SingleValue<Option>) => {
    updateDraftFilterRules({
      columnId: column.columnId,
      value: value?.value as string,
      operator: "equals",
    });
  };

  return (
    <Dropdown
      title={column.columnHeader}
      options={options}
      value={existingValue}
      onChange={updateFilterRule}
    />
  );
}
